import React, { useState, useEffect } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import { promptStyle } from './styles'

import Arrows from '../../assets/Arrows.png'

import lume_studios from '../../assets/SampleVenueImages/lume_studios.png'
import japan_society from '../../assets/SampleVenueImages/711f1525-e031-4305-9595-b40d038af576_Japan_Society_otherPhoto8.jpg'
import apella_by_alexandria from '../../assets/SampleVenueImages/f5d10680-642e-45af-a974-5f87655b2e62_Apella_By_Alexandria_otherPhoto4.jpeg'
import tastings_logo from '../../assets/SampleCateringImages/Tastings_logo.jpg'
import plantea_matcha_logo from '../../assets/SampleCateringImages/Plantea_Matcha_Logo.png'
import subway_logo from '../../assets/SampleCateringImages/SubwayLogo.png'
import capital_one_logo from '../../assets/SampleSponsorImages/CapitalOneLogo.png'
import google_logo from '../../assets/SampleSponsorImages/GoogleLogo.png'
import rho_logo from '../../assets/SampleSponsorImages/Rho_Dark.jpg'

const recommendationsContainerStyle = {
    background: 'linear-gradient(to bottom, #A0BFE0 0%, #7895CB 100%)',
    color: 'white',
    fontSize: '8px',
    fontWeight: '500',
    borderRadius: '5px',
    padding: '8px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    marginBottom: '5px',
}

const imageStyle = {
    width: '40px',
    height: '40px',
    minWidth: '40px',
    borderRadius: '2px',
    objectFit: 'cover',
    backgroundColor: '#b3b3b3',
    display: 'block',
    flexShrink: 0,
}

const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    fontSize: '10px',
    flexGrow: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
}

const landingPagePrompts = [
    'Organizing and AI & Automation Summit in New York City, a two-day conference for 300+ tech executives, AI researchers, and startup founders. The event will feature keynote speeches, panel discussions, and hands-on AI demos.',
    'Need a modern conference venue in New York City for 500 attendees, with a main stage, breakout rooms, and an exhibition space. The venue must have high-speed WiFi, built-in AV equipment, catering services, and easy access to public transportation.',
    'Hosting a one-day startup accelerator workshop in NYC for early-stage AI founders and investors. The schedule includes a keynote, VC panel, product demo sessions, and structured networking.',
]
const landingPageAnimatedVenues = [
    {
        venueName: 'Lume Studios',
        venueCapacity: '50 Seated, 100 Standing',
        venueFeatures: 'Offers in-house catering and beverage',
        imagePath: lume_studios,
    },
    {
        venueName: 'Japan Society',
        venueCapacity: '150 Seated, 200 Standing',
        venueFeatures: 'Offers full sound system and stage',
        imagePath: japan_society,
    },
    {
        venueName: 'Apella by Alexandria',
        venueCapacity: '200 Seated, 350 Standing',
        venueFeatures: 'Modern space offering meeting rooms for brainstorming',
        imagePath: apella_by_alexandria,
    },
]

const landingPageAnimatedCaterers = [
    {
        catererName: 'Tastings',
        catererPackage: 'Standard Package starting at $50/person',
        catererSpecialty: 'Specializes in farm-to-table dishes',
        imagePath: tastings_logo,
    },
    {
        catererName: 'Plantea Matcha',
        catererPackage: 'Premium Package starting at $80',
        catererSpecialty: 'Offers a wide range of international cuisines',
        imagePath: plantea_matcha_logo,
    },
    {
        catererName: 'Subway',
        catererPackage: 'Basic Package starting at $40',
        catererSpecialty: 'Known for their elegant plated dinners',
        imagePath: subway_logo,
    },
]

const landingPageAnimatedSponsors = [
    {
        sponsorName: 'Capital One',
        sponsorPackage: 'Gold Package: $10,000 sponsorship',
        sponsorOfferings: 'Free cloud credits worth $5,000',
        imagePath: capital_one_logo,
    },
    {
        sponsorName: 'Google Inc',
        sponsorPackage: 'Silver Package: $5,000 sponsorship',
        sponsorOfferings: 'Free eco-friendly merchandise for event attendees',
        imagePath: google_logo,
    },
    {
        sponsorName: 'Rho',
        sponsorPackage: 'Bronze Package: $2,500 sponsorship',
        sponsorOfferings:
            'Direct cost offset of $1,000 for event-related expenses',
        imagePath: rho_logo,
    },
]

// Loading placeholder animation component
const LoadingPlaceholder = () => {
    return (
        <motion.div
            style={{
                ...recommendationsContainerStyle,
                backgroundColor: '#A0BFE0',
            }}
            initial={{ opacity: 0.6 }}
            animate={{
                opacity: [0.6, 0.8, 0.6],
                background: ['#A0BFE0', '#8CA7CB', '#A0BFE0'],
            }}
            transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut',
            }}
        >
            <motion.div
                style={{
                    ...imageStyle,
                    background: '#8CA7CB',
                }}
            />
            <div style={textContainerStyle}>
                <motion.div
                    style={{
                        height: '8px',
                        width: '80%',
                        background: '#8CA7CB',
                        borderRadius: '3px',
                        marginBottom: '4px',
                    }}
                    animate={{
                        opacity: [0.6, 0.8, 0.6],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                />
                <motion.div
                    style={{
                        height: '8px',
                        width: '60%',
                        background: '#8CA7CB',
                        borderRadius: '3px',
                        marginBottom: '4px',
                    }}
                    animate={{
                        opacity: [0.6, 0.8, 0.6],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeInOut',
                        delay: 0.2,
                    }}
                />
                <motion.div
                    style={{
                        height: '8px',
                        width: '70%',
                        background: '#8CA7CB',
                        borderRadius: '3px',
                    }}
                    animate={{
                        opacity: [0.6, 0.8, 0.6],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeInOut',
                        delay: 0.4,
                    }}
                />
            </div>
        </motion.div>
    )
}

const RecommendedVenue = ({ index, isLoading }) => {
    // Venues use their own image style because we have better images for venues
    const venueImageStyle = {
        width: '40px',
        height: '40px',
        minWidth: '40px',
        borderRadius: '2px',
        objectFit: 'cover',
        backgroundColor: '#b3b3b3',
        display: 'block',
        flexShrink: 0,
    }

    if (isLoading) return <LoadingPlaceholder />

    const venue = landingPageAnimatedVenues[index]

    return (
        <motion.div
            style={recommendationsContainerStyle}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
        >
            <motion.img
                src={venue.imagePath}
                alt={venue.venueName}
                style={venueImageStyle}
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
            />
            <div style={textContainerStyle}>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Recommended Venue: <strong>{venue.venueName}</strong>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Venue Capacity: {venue.venueCapacity}
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Venue Features: {venue.venueFeatures}
                </motion.div>
            </div>
        </motion.div>
    )
}

const RecommendedCatering = ({ index, isLoading }) => {
    if (isLoading) return <LoadingPlaceholder />

    const caterer = landingPageAnimatedCaterers[index]

    return (
        <motion.div
            style={recommendationsContainerStyle}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
        >
            <motion.img
                src={caterer.imagePath}
                alt={caterer.catererName}
                style={imageStyle}
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
            />
            <div style={textContainerStyle}>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Recommended Caterer: <strong>{caterer.catererName}</strong>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Catering Package: {caterer.catererPackage}
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Catering Specialty: {caterer.catererSpecialty}
                </motion.div>
            </div>
        </motion.div>
    )
}

const RecommendedSponsors = ({ index, isLoading }) => {
    if (isLoading) return <LoadingPlaceholder />

    const sponsor = landingPageAnimatedSponsors[index]

    return (
        <motion.div
            style={recommendationsContainerStyle}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
        >
            <motion.img
                src={sponsor.imagePath}
                alt={sponsor.sponsorName}
                style={imageStyle}
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
            />
            <div style={textContainerStyle}>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Recommended Sponsor: <strong>{sponsor.sponsorName}</strong>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Sponsor Package: {sponsor.sponsorPackage}
                </motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    Sponsor Offerings: {sponsor.sponsorOfferings}
                </motion.div>
            </div>
        </motion.div>
    )
}

const AIPrompt = ({ index }) => {
    return (
        <motion.div
            style={{
                ...promptStyle,
                width: '100%',
                minHeight: '50px',
                maxHeight: '80px',
                fontSize: '11px',
                padding: '8px',
                boxSizing: 'border-box',
                margin: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            {landingPagePrompts[index]}
        </motion.div>
    )
}

const LandingPageAnimation = () => {
    const [currentPromptIndex, setCurrentPromptIndex] = useState(0)
    const [currentVenueIndex, setCurrentVenueIndex] = useState(0)
    const [currentCatererIndex, setCurrentCatererIndex] = useState(0)
    const [currentSponsorIndex, setCurrentSponsorIndex] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [windowHeight, setWindowHeight] = useState(window.innerHeight)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setWindowWidth(window.innerWidth);
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const animationCycle = async () => {
            // Cycle through prompts
            setCurrentPromptIndex(
                (prevIndex) => (prevIndex + 1) % landingPagePrompts.length
            )

            // Show loading state
            await new Promise((resolve) => setTimeout(resolve, 1000))
            setIsLoading(true)

            // Show recommendations after loading
            await new Promise((resolve) => setTimeout(resolve, 1500))
            setIsLoading(false)
            setCurrentVenueIndex(
                (prevIndex) => (prevIndex + 1) % landingPageAnimatedVenues.length
            )
            setCurrentCatererIndex(
                (prevIndex) =>
                    (prevIndex + 1) % landingPageAnimatedCaterers.length
            )
            setCurrentSponsorIndex(
                (prevIndex) =>
                    (prevIndex + 1) % landingPageAnimatedSponsors.length
            )
        }

        // Start the animation cycle
        const interval = setInterval(animationCycle, 8000)

        // Clean up on unmount
        return () => clearInterval(interval)
    }, [])

    // Determine if we should show the arrows based on screen width
    const showArrows = windowWidth > 480;
    
    // Calculate appropriate height for mobile
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const mobileHeight = isMobileDevice ? (windowHeight * 0.6) : 'auto';

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: { xs: '100%', sm: '100%', md: '100%' },
                height: { xs: 'auto', md: 'auto' },
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                borderRadius: { xs: '10px', md: '12px' },
                padding: { xs: '10px', sm: '12px', md: '15px' },
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: { xs: '8px', md: '10px' },
                margin: { xs: '0 auto', md: '0' },
                overflow: 'hidden',
                boxSizing: 'border-box',
            }}
        >
            <AIPrompt index={currentPromptIndex} />
            
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    flexGrow: 1,
                    overflow: 'hidden',
                }}
            >
                {showArrows && (
                    <Box
                        sx={{
                            display: { xs: 'none', sm: 'flex' },
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            height: '100%',
                            width: '15%',
                            maxWidth: '60px',
                            pt: 2,
                        }}
                    >
                        <img
                            src={Arrows}
                            style={{ 
                                width: '100%',
                                maxWidth: '50px',
                                objectFit: 'contain'
                            }}
                            alt="Arrows"
                        />
                    </Box>
                )}
                
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: '8px', md: '10px' },
                        width: showArrows ? '85%' : '100%',
                        alignItems: 'center',
                        overflow: 'auto',
                        flexGrow: 1,
                        height: '100%',
                    }}
                >
                    <RecommendedVenue
                        index={currentVenueIndex}
                        isLoading={isLoading}
                    />
                    <RecommendedCatering
                        index={currentCatererIndex}
                        isLoading={isLoading}
                    />
                    <RecommendedSponsors
                        index={currentSponsorIndex}
                        isLoading={isLoading}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default LandingPageAnimation
